// extracted by mini-css-extract-plugin
export default {"Antecedent":"AffichageSyntheseAntecedents_Antecedent__qz+-u"};